import { useEffect, useRef, useState } from "react";
import "./WidgetItem.css"
import WidgetDeadlines from "./WidgetItemDeadlines";
import WidgetPriority from "./WidgetItemPriority";
import WidgetLabel from "./WidgetItemLabel";
import WidgetTextHtml from "./WidgetItemTextHtml";
import WidgetCheckList from "./checkList/WidgetCheckList";
import WidgetParameter from "./parameter/WidgetParameter";
import WidgetFile from "./file/WidgetFile";
import { faDatabase, faFile, faListCheck, faQuoteLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SrvButtonLink from "../../global/SrvButtonLink";
import { Modal } from "react-bootstrap";
import SrvButton from "../../global/SrvButton";
import { useDrag, useDrop } from "react-dnd";
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";

function WidgetItem({ idObject, idTab, idWidget, idTask, idTask2, idProject, number, moving, editMode, nameWidget, showTracker, widgetMoving, widgetMovingSave, index, onlyRead, addedWidget }) {

    //moving - Перемещающийся
    //showTracker - Показывать в трекере задач. Для регулярных задач
    //addedWidget - ID добавленного виджета. Для того чтобы перевести его в режим редактирования
    /*
    idObject:
    1	Задача
    2	Регулярная задача
    6   Регулярная задача. Трекер
    3	Доска
    4	Проект
    5	Пользователь
        */
    /*
        ID	Name
        1	Сроки (Не изменяемая)
        2	Приоритет (Не изменяемая)
        3	Метки (Не изменяемая)
        4	Текст HTML
        5	Чек-лист
        6	Файлы
        7	Параметры
    */
    /*        
         [ID_Board_Task]
        ,[ID_Widget]
        ,[Number]
        ,[Name]
        ,[Order]
    */

    const [formShowTracker, setFormShowTracker] = useState(true);//Отображать в «Текущих задачах?»
    const [formRequiredCompleted, setFormRequiredCompleted] = useState(false);//Обязательно к выполнению
    const [formName, setFormName] = useState(null);
    const [editShow, setEditShow] = useState(false);
    const [removeModalShow, setRemoveModalShow] = useState(false);

    const [logName, setLogName] = useState(null);
    const [logRemove, setLogRemove] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setFormName(nameWidget);
        setFormShowTracker(showTracker);

        //ЗАГРУЖАЕМ ПАРАМЕТРЫ
        if (idWidget === 5 & idObject === 2 & idTask !== null) {
            axios.get('/api_tracker/taskR/widgetParameterServiceList', { params: { ID_TaskR: idTask, ID_Widget: idWidget, Number: number } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        if (res.data.Data.filter(a => a.ID_Parameter === 2).length === 1) {
                            setFormRequiredCompleted(res.data.Data.filter(a => a.ID_Parameter === 2)[0].Value_Bool)
                        }
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });

        }
    }, [showTracker, nameWidget]);

    function widgetRemoveHandler() {
        setLogRemove(null);
        setLoading(true);

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetRemove', { ID_Task: idTask, ID_Widget: idWidget, Number: number })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setRemoveModalShow(false);
                        setLoading(false);
                    }
                    else {
                        setLogRemove(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogRemove('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetRemove', { ID_TaskR: idTask, ID_Widget: idWidget, Number: number })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setRemoveModalShow(false);
                        setLoading(false);
                    }
                    else {
                        setLogRemove(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogRemove('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetRemove', { ID_Board_Task: idTask, ID_Widget: idWidget, Number: number })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setRemoveModalShow(false);
                        setLoading(false);
                    }
                    else {
                        setLogRemove(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogRemove('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

        }
    }

    function widgetUpdateHandler() {
        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetUpdate', { ID_Task: idTask, ID_Widget: idWidget, Number: number, Name: formName })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEditShow(false);
                        setLoading(false);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetUpdate', { ID_TaskR: idTask, ID_Widget: idWidget, Number: number, Name: formName, Show_Tracker: formShowTracker })
                .then((res) => {
                    if (res.data.Status === 1) {
                        //Добавляем значения параметров
                        axios.post('/api_tracker/taskR/widgetParameterServiceSet', { ID_TaskR: idTask, ID_Widget: idWidget, Number: number, ID_Parameter: 2, Value_Bool: formRequiredCompleted })
                            .then((res1) => {
                                if (res1.data.Status === 1) {
                                    setEditShow(false);
                                    setLoading(false);
                                }
                                else {
                                    setLogName(res1.data.Error);
                                    setLoading(false);
                                }
                            })
                            .catch((err) => {
                                setLogName('Неизвестная ошибка!');
                                setLoading(false);
                            });
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetUpdate', { ID_Board_Task: idTask, ID_Widget: idWidget, Number: number, Name: formName })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEditShow(false);
                        setLoading(false);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

        }
    }

    const ref = useRef(null)

    const [{ handlerId }, drop] = useDrop({
        accept: "widget_" + idTask,
        drop: () => ({
            // model, //Передаем в useDrag
        }),
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }

            const dragIndex = item.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action

            widgetMoving({ dragIndex: dragIndex, hoverIndex: hoverIndex })
            item.index = hoverIndex;
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: "widget_" + idTask,
        item: () => {
            return { idWidget, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //item - Изменяемая модель
            if (monitor.getDropResult() !== null) {
                widgetMovingSave()
            }
        }
    })
    const opacity = isDragging ? 0 : 1

    if (onlyRead !== true & editMode === true) {
        drag(drop(ref))
    }
    else {
        drag(null)
        //drag(drop(ref))
    }

    return (
        <>
            {moving === true ?
                (
                    <div className={editMode === true ? "card_widget_block edit" : "card_widget_block"} ref={ref} data-handler-id={handlerId} style={{ opacity }}>
                        <div className={editMode === true ? "card_widget_name edit" : "card_widget_name"}>
                            {nameWidget !== null && (
                                <>
                                    {idWidget === 4 && (<div><FontAwesomeIcon className="mr-5" icon={faQuoteLeft} /></div>)}
                                    {idWidget === 5 && (<div><FontAwesomeIcon className="mr-5" icon={faListCheck} /></div>)}
                                    {idWidget === 6 && (<div><FontAwesomeIcon className="mr-5" icon={faFile} /></div>)}
                                    {idWidget === 7 && (<div><FontAwesomeIcon className="mr-5" icon={faDatabase} /></div>)}
                                    {nameWidget}
                                </>
                            )}
                            {editMode === true && (
                                <div style={{ marginLeft: "auto" }}>
                                    <div className="text-danger" style={{ display: "inline-block", marginLeft: "5px" }}><SrvButtonLink typeBtn="remove" textBtn="" onClick={() => setRemoveModalShow(true)} /></div>
                                </div>
                            )}
                        </div>
                        {idWidget === 4 && (<WidgetTextHtml idObject={idObject} idTask={idTask} idWidget={idWidget} number={number} editMode={editMode} added={addedWidget} onlyRead={onlyRead} name={nameWidget} nameChange={setFormName} showTracker={showTracker} showTrackerChange={setFormShowTracker} widgetUpdateHandler={widgetUpdateHandler} />)}
                        {idWidget === 5 && (<WidgetCheckList key={idWidget + '_' + number} idObject={idObject} idTab={idTab} idTask={idTask} idWidget={idWidget} number={number} editMode={editMode} added={addedWidget} onlyRead={onlyRead} name={nameWidget} nameChange={setFormName} showTracker={showTracker} showTrackerChange={setFormShowTracker} widgetUpdateHandler={widgetUpdateHandler} requiredCompleted={formRequiredCompleted} requiredCompletedChange={setFormRequiredCompleted} />)}
                        {idWidget === 6 && (<WidgetFile idObject={idObject} idTask={idTask} idWidget={idWidget} number={number} editMode={editMode} added={addedWidget} onlyRead={onlyRead} name={nameWidget} nameChange={setFormName} showTracker={showTracker} showTrackerChange={setFormShowTracker} widgetUpdateHandler={widgetUpdateHandler} />)}
                        {idWidget === 7 && (<WidgetParameter idObject={idObject} idTask={idTask} idWidget={idWidget} number={number} editMode={editMode} added={addedWidget} onlyRead={onlyRead} name={nameWidget} nameChange={setFormName} showTracker={showTracker} showTrackerChange={setFormShowTracker} widgetUpdateHandler={widgetUpdateHandler} idProject={idProject} />)}
                    </div>
                )
                :
                (
                    <>
                    </>
                    /*<div className={editMode === true ? "card_widget_block__ edit__" : "card_widget_block__"} >
                        {idWidget === 1 && (<WidgetDeadlines idObject={idObject} idWidget={idWidget} number={number} idItem={idTask} onlyRead={onlyRead} added={addedWidget}/*updateHandler={updateHandler}*//* />)}
/* {idWidget === 2 && (<WidgetPriority idObject={idObject} idWidget={idWidget} number={number} idItem={idTask} onlyRead={onlyRead} added={addedWidget}/*updateHandler={updateHandler}*//* />)}
                                                                                                                              {idWidget === 3 && (<WidgetLabel idObject={idObject} idTab={idTab} idWidget={idWidget} number={number} idItem={idTask} idItem2={idTask2} onlyRead={onlyRead} idProject={idProject} added={addedWidget} />)}
                                                                                                                              {editMode === true && (
                                                                                                                                  <div style={{ textAlign: "center" }}>
                                                                                                                                      <div className="text-danger" style={{ display: "inline-block", marginLeft: "5px" }}><SrvButtonLink typeBtn="remove" textBtn="Удалить" onClick={() => setRemoveModalShow(true)} /></div>
                                                                                                                                  </div>
                                                                                                                              )}
                                                                                                                          </div>*/
                )
            }
            {removeModalShow === true && (
                <Modal show={removeModalShow} onHide={() => setRemoveModalShow(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={() => setRemoveModalShow(false)}> <FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>

                        <div className="modal_title text-center mb-15">Удаление виджета</div>
                        <div className="fs-5 text-center">Подтвердите удаление виджета.</div>
                        <div className="fs-5 text-center"><b>Внимание!</b></div>
                        <div className="fs-5 text-center">При удалении виджета будут удалены все связанные с ним записи</div>
                        {logRemove !== null && <div className="form_error text-center mt-15">{logRemove}</div>}
                        <div className='row mt-15'>
                            <div className='col-md-12 text-center'>
                                <SrvButton typeBtn='remove' size='lg' onClick={widgetRemoveHandler} loading={loading} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )
            }
        </>
    )
}

export default WidgetItem;